import { parseTypedDay } from './typed-date.mjs?v=20260806.100';

/**
 * What staff type into Report Empty (Alan, 2026-09-29: "点击报空并且需要加上地点比如
 * 9/28空611"): the day it was reported, the word 空, and where the empty is - "9/28空611".
 * That is how the ops sheet already writes it, so it is typed the same way here
 * instead of asking for a date box and an address box.
 *
 *   9/28空611   -> reported 9/28, at 611   (the place shows in the Reported Empty cell itself)
 *   空611       -> reported now, at 611
 *   611         -> reported now, at 611   (nothing that reads as a day is a location)
 *   9/28        -> reported 9/28, no location
 *   (blank)     -> reported now, no location - the old one-press behaviour
 *
 * The day is stored the way the date picker stores one (noon UTC), "now" the way
 * the one-press button always sent it. A day that is not a day is refused rather
 * than read as a location: "9/31空611" saved as a place called "9/31空611" would
 * put a date into an address column and report nothing.
 */
export function parseReportedEmptyEntry(raw, now = Date.now()) {
  const text = String(raw ?? '').replace(/\s+/g, ' ').trim();
  const nowIso = new Date(now).toISOString();
  if (!text) return { reportedAt: nowIso, location: '' };

  const marker = text.indexOf('空');
  if (marker >= 0) {
    const dayText = text.slice(0, marker).trim();
    const location = text.slice(marker + 1).trim();
    if (!dayText) return { reportedAt: nowIso, location };
    const day = parseTypedDay(dayText, now);
    return day ? { reportedAt: `${day}T12:00:00.000Z`, location } : { error: 'date' };
  }

  const day = parseTypedDay(text, now);
  if (day) return { reportedAt: `${day}T12:00:00.000Z`, location: '' };
  // Looks like an attempt at a date ("9/31", "13/2") but is not one.
  if (/^\d{1,2}[/-]\d{1,2}(?:[/-]\d{2,4})?$/u.test(text)) return { error: 'date' };
  return { reportedAt: nowIso, location: text };
}
